import React from 'react';
import { createPortal } from 'react-dom';
import AddShoppingCart from '@mui/icons-material/AddShoppingCart';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import ARIA_LABELS from 'constants/ariaLabels';
import './ShellCartFloatingButton.scss';

type ShellCartFloatingButtonProps = {
    disabled: boolean;
    onClick: () => void;
    totalItems: number;
};

const ShellCartFloatingButton: React.FC<ShellCartFloatingButtonProps> = ({
    disabled,
    onClick,
    totalItems,
}) => {
    const ariaLabel = totalItems === 0
        ? ARIA_LABELS.CART.emptyCart
        : ARIA_LABELS.CART.cartWithItems(totalItems);
    const isIOSShellApp = window.platform?.toLowerCase() === 'ios';

    return createPortal(
        <IconButton
            aria-label={ariaLabel}
            className={`shell-cart-floating-button cart-badge-count m-0 position-fixed${isIOSShellApp ? ' shell-cart-floating-button-ios' : ''}`}
            disabled={disabled}
            onClick={onClick}
        >
            <Badge badgeContent={totalItems} max={999}>
                <AddShoppingCart
                    aria-hidden="true"
                />
            </Badge>
        </IconButton>,
        document.body,
    );
};

export default ShellCartFloatingButton;
